<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>C端数据管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户注册信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">注册信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="80px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label-width="120px" label="学校省市区" prop="schoolArea">
              <el-cascader
                placeholder="请选择"
                clearable
                v-model="schoolArea"
                ref="schoolAreaRef"
                :options="areasData"
                style="width: 100%"
                :props="{
                  expandTrigger: 'hover',
                  label: 'name',
                  value: 'id',
                  children: 'areas',
                }"
                @change="provincesHandleChangeSearch"
              ></el-cascader>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="学校" prop="schoolId">
              <!-- <el-select
                ref="schoolSelectRef"
                style="width: 100%"
                placeholder="请选择"
                v-model="queryForm.schoolId"
                clearable
                filterable
              >
                <el-option
                  v-for="item in provincesSchoolListSearch"
                  :key="item.id"
                  :label="item.schoolName"
                  :value="item.id"
                ></el-option>
              </el-select> -->
              <el-select
                v-model="queryForm.schoolId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                  v-for="item in schools"
                  :key="item.id"
                  :label="item.schoolName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="来源" prop="source">
              <el-select v-model="queryForm.source" placeholder="请选择">
                <el-option label="国内选手" :value="1"></el-option>
                <el-option label="海外机构负责人" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="getDataList('search')"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 注册信息列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">注册信息列表</span
          >
        </el-col>
        <el-col :span="15" style="text-align: right;">
          <el-button type="primary" @click="editExamineeTypeClicked()"
              >新增用户+</el-button
            >
          <el-button
            type="primary"
            @click="exportTable()"
            >导出</el-button
          >
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="账号" prop="phone"></el-table-column>
        <el-table-column label="姓名" prop="userName"></el-table-column>
        <el-table-column
          label="性别"
          prop="sex"
          :formatter="genderFormatter"
        ></el-table-column>
        <el-table-column
          v-if="queryForm.identity !== 3"
          label="组别"
          prop="level"
          :formatter="groupFormatter"
        ></el-table-column>
        <el-table-column v-if="queryForm.identity !== 3" label="学校" prop="schoolName"></el-table-column>
        <el-table-column v-if="queryForm.identity !== 3" label="年级" prop="grade"></el-table-column>
        <el-table-column
          v-if="queryForm.identity !== 3"
          label="证件类型"
          prop="cardType"
          :formatter="cardTypeFormatter"
        ></el-table-column>
        <el-table-column v-if="queryForm.identity !== 3" label="证件号码" prop="idCard"></el-table-column>
        <!-- <el-table-column label="省市区" prop="provence">
          <template slot-scope="scope">
            <span
              >{{ scope.row.provinceName }}/{{ scope.row.cityName }}/{{
                scope.row.countyName
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="学校" prop="schoolName">
          <template slot-scope="scope">
            <span
              v-if="scope.row.fillschoolName && scope.row.fillschoolName !== ''"
              >{{ scope.row.fillschoolName }}</span
            >
            <span v-else>{{ scope.row.schoolName }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          label="年级"
          prop="grade"
          :formatter="gradeFormatter"
        ></el-table-column> -->
        <el-table-column label="邮箱" prop="email"></el-table-column>
        <el-table-column v-if="queryForm.identity !== 3" label="来源" prop="source">
          <template slot-scope="scope">
            {{ scope.row.source == 2 ? '海外机构负责人' : '国内选手' }}
          </template>
        </el-table-column>
        <el-table-column label="注册时间" prop="createTime"></el-table-column>
        <el-table-column label="操作" :width="queryForm.identity === 3 ? '180px' : '80px'">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="showDetailsClicked(scope.row)"
              >查看详情</el-button
            >
            <el-button
              v-if="queryForm.identity === 3"
              type="text"
              size="small"
              @click="bindDistrictClicked(scope.row)"
              >绑定赛区数据</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 编辑信息的dialog -->
    <el-dialog
      :title="editInfoForm.identity === 3 ? '添加海外机构负责人信息' : '添加注册信息'"
      :visible.sync="editInfoDialogVisible"
      width="60%"
      @close="editInfoDialogClose"
    >
      <el-form
        :model="editInfoForm"
        label-width="100px"
        ref="editInfoFormRef"
        :rules="editInfoRules"
        style="width: 100%"
      >
      <el-row>
        <el-col :span="12">
          <!-- 海外机构负责人输入邮箱 -->
          <el-form-item v-if="editInfoForm.identity === 3" label="邮箱" prop="emails">
            <el-input v-model="editInfoForm.emails" placeholder="请输入（多邮箱用,分割）">
            </el-input>
          </el-form-item>
          <!-- 国内选手输入手机号 -->
          <el-form-item v-else label="手机号" prop="phones">
            <el-input v-model="editInfoForm.phones" placeholder="请输入（多手机号用,分割）">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="赛区" prop="districtId">
            <el-select
              v-model="editInfoForm.districtId"
              placeholder="请选择赛区"
              clearable
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="item in districtList"
                :key="item.id"
                :label="item.districtName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="editInfoForm.phone" placeholder="请输入">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="editInfoForm.userName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件类型" prop="cardType">
              <el-select
                placeholder="请选择"
                v-model="editInfoForm.cardType"
                style="width: 100%"
              >
                <el-option
                  v-for="item in card_type"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号码" prop="idCard">
              <el-input
                style="width: 100%"
                v-model="editInfoForm.idCard"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="出生日期" prop="dateBirth">
              <el-date-picker
                :picker-options="pickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="editInfoForm.dateBirth"
                type="date"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-select
                placeholder="请选择"
                v-model="editInfoForm.sex"
                style="width: 100%"
              >
                <el-option
                  v-for="item in e_sex"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="editInfoForm.email"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学校地区" prop="schoolArea">
              <el-cascader
                placeholder="请选择"
                v-model="editInfoForm.schoolArea"
                ref="schoolAreaRef"
                :options="areasData"
                style="width: 100%"
                :props="{
                  expandTrigger: 'hover',
                  label: 'name',
                  value: 'id',
                  children: 'areas',
                }"
                @change="provincesHandleChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="学校" prop="schoolId">
              <el-select
                ref="mailingInfoModelSchoolSelectRef"
                style="width: 100%"
                placeholder="请选择"
                v-model="editInfoForm.schoolId"
                clearable
                filterable
              >
                <el-option
                  v-for="item in provincesSchoolList"
                  :key="item.id"
                  :label="item.schoolName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年级" prop="grade">
              <el-select
                style="width: 100%"
                placeholder="请选择年级"
                v-model="editInfoForm.grade"
                clearable
                @change="userGradeselectClicked"
              >
                <el-option
                  v-for="item in dict_grade"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editInfoDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editInfo">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 绑定赛区数据dialog -->
    <el-dialog
      title="绑定赛区数据"
      :visible.sync="bindDistrictDialogVisible"
      width="50%"
      @close="bindDistrictDialogClose"
    >
      <el-form
        :model="bindDistrictForm"
        label-width="100px"
        ref="bindDistrictFormRef"
        style="width: 100%"
      >
        <el-form-item label="赛区" prop="districtIds">
          <el-select
            v-model="bindDistrictForm.districtIds"
            placeholder="请选择赛区"
            multiple
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="item in districtList"
              :key="item.id"
              :label="item.districtName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bindDistrictDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveBindDistrict">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import areasData from '@/assets/area.json'
import { getSysUserList, getSchoolListWithCity, fastAddSysUser, fastAddSysUserByEmail, queryDistrictPage, queryOverseasUserDistrictList, addOverseasUserDistrict } from '@/http/api'
export default {
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      timer: new Date().getTime(),
      queryForm: {
        phone: '',
        name: '',
        schoolId: '',
        identity: 1, // 1-国内选手，3-海外机构负责人
        pageNum: 1,
        pageSize: 10
      },
      schoolArea: null,
      editInfoForm: {
        phones: '',
        emails: '', // 海外机构负责人邮箱字段
        userName: '',
        identity: 1, // 1-国内选手，3-海外机构负责人
        sex: '',
        cardType: '',
        email: '',
        idCard: '',
        dateBirth: '',
        schoolArea: [],
        schoolId: '',
        grade: '',
        districtId: '' // 赛区ID
      },
      editInfoRules: {
        phones: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        emails: [{ required: true, message: '请输入邮箱', trigger: 'blur' }]
        // userName: [{ required: true, message: '请输入', trigger: 'blur' }],
        // sex: [{ required: true, message: '请选择', trigger: 'change' }],
        // cardType: [{ required: true, message: '请选择', trigger: 'change' }],
        // email: [{ required: true, message: '请输入', trigger: 'blur' }],
        // idCard: [{ required: true, message: '请输入', trigger: 'blur' }],
        // dateBirth: [{ required: true, message: '请选择', trigger: 'change' }],
        // schoolArea: [{ required: true, message: '请选择', trigger: 'change' }],
        // schoolId: [{ required: true, message: '请选择', trigger: 'change' }],
        // grade: [{ required: true, message: '请选择', trigger: 'change' }]
      },

      editInfoSchoolList: [], // 学校数组
      editInfoDialogVisible: false,
      total: 0,
      dict_group: this.$userInfo.dict_group(),
      e_sex: this.$userInfo.getDataList(this, 'e_sex').then(value => { this.e_sex = value }),
      card_type: this.$userInfo.getDataList(this, 'card_type').then(value => { this.card_type = value }),
      dict_grade: this.$userInfo.getGradeData(),
      dataList: [],
      areasData: areasData.areas,
      provincesSchoolList: [],
      provincesSchoolListSearch: [],
      loading: false,
      schoolName: '',
      schools: [],
      districtList: [], // 赛区列表
      bindDistrictDialogVisible: false, // 绑定赛区对话框显示状态
      bindDistrictForm: {
        userId: '', // 用户ID
        districtIds: [] // 选中的赛区ID数组
      }
    }
  },
  created () {
    // 检查是否从上个界面传入overseas参数
    const overseas = this.$route.query.overseas
    if (overseas === '1') {
      this.queryForm.identity = 3 // 海外机构负责人
      this.editInfoForm.identity = 3 // 海外机构负责人
    } else {
      this.queryForm.identity = 1 // 国内选手
      this.editInfoForm.identity = 1 // 国内选手
    }
    this.getDataList()
  },
  methods: {
    remoteMethod (query) {
      console.log(query)
      this.schoolName = query
      if (query !== '') {
        this.loading = true
        this.getAllSchools()
      } else {
        this.schools = []
      }
    },
    getAllSchools () {
      this.$http.get('/school/getSysSchoolList', { params: { pageSize: 10000, pageNum: 1, schoolName: this.schoolName } }).then(res => {
        if (res.code === 200) {
          this.loading = false
          this.schools = res.data.list
        }
      })
    },
    goBack () {
      this.$router.back()
    },
    // 获取列表信息
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      getSysUserList(this.queryForm).then((res) => {
        console.log('getSysUserList', res)
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    editExamineeTypeClicked () {
      this.editInfoDialogVisible = true
      // 打开弹窗时获取赛区列表
      this.getDistrictList()
    },
    // 学校省市区选择
    provincesHandleChange (value) {
      if (!value) return
      this.provincesSchoolList = []
      this.editInfoForm.schoolName = ''
      this.editInfoForm.schoolId = ''
      this.editInfoForm.provinceCode = value[0]
      this.editInfoForm.cityCode = value[1]
      this.editInfoForm.areaCode = value[2]
      const deliveryAreaName = this.$refs.schoolAreaRef.getCheckedNodes()[0].pathLabels.join('/')
      const areaList = deliveryAreaName.split('/')
      this.editInfoForm.province = areaList[0]
      this.editInfoForm.city = areaList[1]
      this.editInfoForm.area = areaList[2]
      console.log('editInfoForm', this.editInfoForm)
      this.getSchoolListData(value, 2)
    },
    // 获取学校List
    getSchoolListData (schoolArea, type) {
      getSchoolListWithCity({ provinceCode: schoolArea[0], cityCode: schoolArea[1], areaCode: schoolArea[2] }).then((res) => {
        console.log('getSchoolList', res)
        if (type === 1) {
          this.provincesSchoolListSearch = res.data
        } else if (type === 2) {
          this.provincesSchoolList = res.data
        }
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 用户年级选择转换组别
    userGradeselectClicked () {
      const gradeData = this.$userInfo.getUserGroupWithGrade(this.editInfoForm.grade)
      this.editInfoForm.group = gradeData.userGradeStr
      this.editInfoForm.level = gradeData.groupId
    },
    // 查看用户详情
    showDetailsClicked (rowData) {
      console.log('rowData', rowData)
      this.$router.push(
        {
          path: '/c_data_Management/c_player_registInfo_details',
          query: {
            userId: rowData.id
          }
        }
      )
    },
    // 保存用户信息
    editInfo () {
      this.$refs.editInfoFormRef.validate(async valid => {
        if (!valid) return

        // 根据identity选择不同的接口
        const apiMethod = this.editInfoForm.identity === 3 ? fastAddSysUserByEmail : fastAddSysUser
        const apiName = this.editInfoForm.identity === 3 ? 'fastAddSysUserByEmail' : 'fastAddSysUser'
        apiMethod(this.editInfoForm).then((res) => {
          console.log(apiName, res)
          this.editInfoDialogVisible = false
          this.$message.success('添加成功')
          this.getDataList()
        }).catch((err) => {
          console.log('err', err)
        })
        // if (!this.$xcUtils.checkPhone(this.editInfoForm.phone)) return this.$message.warning('请输入正确手机号')
        // if (this.editInfoForm.cardType === '1') {
        //   if (!this.$xcUtils.checkIdCard(this.editInfoForm.idCard)) return this.$message.warning('请输入正确证件号')
        // }
        // if (!this.$xcUtils.checkEmail(this.editInfoForm.email)) return this.$message.warning('请输入正确邮箱')
        // this.editInfoForm.schoolName = this.$refs.mailingInfoModelSchoolSelectRef.selectedLabel
        // var sysUserDto = {}
        // sysUserDto.cardType = this.editInfoForm.cardType
        // sysUserDto.dateBirth = this.editInfoForm.dateBirth
        // sysUserDto.email = this.editInfoForm.email
        // sysUserDto.idCard = this.editInfoForm.idCard
        // sysUserDto.phone = this.editInfoForm.phone
        // sysUserDto.sex = this.editInfoForm.sex
        // sysUserDto.userName = this.editInfoForm.userName
        // var sysUserInfoDto = {}
        // sysUserInfoDto.area = this.editInfoForm.area
        // sysUserInfoDto.areaCode = this.editInfoForm.areaCode
        // sysUserInfoDto.city = this.editInfoForm.city
        // sysUserInfoDto.cityCode = this.editInfoForm.cityCode
        // sysUserInfoDto.level = this.editInfoForm.level
        // sysUserInfoDto.nationality = this.editInfoForm.nationality
        // sysUserInfoDto.nationalityCode = this.editInfoForm.nationalityCode
        // sysUserInfoDto.province = this.editInfoForm.province
        // sysUserInfoDto.provinceCode = this.editInfoForm.provinceCode
        // sysUserInfoDto.schoolId = this.editInfoForm.schoolId
        // sysUserInfoDto.schoolName = this.editInfoForm.schoolName
        // var saveForm = {}
        // saveForm.sysUserDto = sysUserDto
        // saveForm.sysUserInfoDto = sysUserInfoDto
        // saveSysUserAll(saveForm).then((res) => {
        //   console.log('saveForm', res)
        //   this.editInfoDialogVisible = false
        //   this.$message.success('添加成功')
        //   this.getDataList()
        // }).catch((err) => {
        //   console.log('err', err)
        // })
      })
    },
    // 重置搜索条件
    reset () {
      this.schoolArea = null
      this.$refs.queryFormRef.resetFields()
      this.schools = []
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    genderFormatter (data) {
      var temp = '未知'
      for (const key in this.e_sex) {
        if (Object.hasOwnProperty.call(this.e_sex, key)) {
          const element = this.e_sex[key]
          if (element.dictValue === data.sex + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    cardTypeFormatter (data) {
      var temp = '未知'
      for (const key in this.card_type) {
        if (Object.hasOwnProperty.call(this.card_type, key)) {
          const element = this.card_type[key]
          if (element.dictValue === data.cardType + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    groupFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_group) {
        if (Object.hasOwnProperty.call(this.dict_group, key)) {
          const element = this.dict_group[key]
          if (element.dictValue === data.level + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    gradeFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_grade) {
        if (Object.hasOwnProperty.call(this.dict_grade, key)) {
          const element = this.dict_grade[key]
          if (element.dictValue === data.grade + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    // 获取赛区列表
    getDistrictList (identity) {
      // 如果传入了identity参数，使用传入的值；否则使用editInfoForm.identity
      const currentIdentity = identity !== undefined ? identity : this.editInfoForm.identity
      const regionType = currentIdentity === 3 ? 'overseas' : 'domestic'
      const params = {
        pageNum: 1,
        pageSize: 10000,
        regionType: regionType
      }
      return queryDistrictPage(params).then((res) => {
        console.log('getDistrictList', res)
        this.districtList = res.data.list || []
        return res
      }).catch((err) => {
        console.log('获取赛区列表失败', err)
        this.$message.error('获取赛区列表失败')
        throw err
      })
    },
    editInfoDialogClose () {
      this.$refs.editInfoFormRef.resetFields()
      // 重置表单时清空邮箱和手机号字段
      this.editInfoForm.phones = ''
      this.editInfoForm.emails = ''
      this.editInfoForm.districtId = ''
    },
    exportTable () {
      const { pageNum, pageSize, ...newForm } = this.queryForm
      const downLoadUrl = `${this.$http.defaults.baseURL}erpUser/excelQuerySysUserList?${this.$xcUtils.serialize(newForm)}`
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl)
    },
    // 学校省市区选择
    provincesHandleChangeSearch (value) {
      console.log('value', value)
      if (!value) return
      this.provincesSchoolListSearch = []
      this.queryForm.schoolId = ''
      this.getSchoolListData(value, 1)
    },
    // 点击绑定赛区数据按钮
    async bindDistrictClicked (row) {
      this.bindDistrictForm.userId = row.id
      this.bindDistrictDialogVisible = true
      // 打开弹窗时获取赛区列表，传入identity为3（海外机构负责人）
      await this.getDistrictList(3)
      // 查询该用户已绑定的赛区数据并回显
      this.getUserBoundDistricts(row.id)
    },
    // 查询用户已绑定的赛区数据
    getUserBoundDistricts (userId) {
      const params = {
        id: userId
      }
      queryOverseasUserDistrictList(params).then((res) => {
        console.log('getUserBoundDistricts', res)
        // 将返回的赛区ID数组设置到表单中
        let districtIds = []
        if (res.data) {
          // 情况1: 直接是数组 [1, 2, 3]
          if (Array.isArray(res.data)) {
            districtIds = res.data.map(item => {
              // 如果返回的是对象，取districtId或id字段；如果是数字，直接使用
              return typeof item === 'object' ? (item.districtId || item.id) : item
            })
          } else if (res.data.list && Array.isArray(res.data.list)) {
            // 情况2: 对象中包含list数组 { list: [{districtId: 1}, ...] }
            districtIds = res.data.list.map(item => {
              return typeof item === 'object' ? (item.districtId || item.id) : item
            })
          } else if (res.data.districtIds && Array.isArray(res.data.districtIds)) {
            // 情况3: 对象中包含districtIds数组 { districtIds: [1, 2, 3] }
            districtIds = res.data.districtIds
          }
        }
        this.bindDistrictForm.districtIds = districtIds
      }).catch((err) => {
        console.log('查询已绑定赛区失败', err)
        this.$message.error('查询已绑定赛区失败')
        this.bindDistrictForm.districtIds = []
      })
    },
    // 保存绑定赛区数据
    saveBindDistrict () {
      // if (!this.bindDistrictForm.districtIds || this.bindDistrictForm.districtIds.length === 0) {
      //   this.$message.warning('请至少选择一个赛区')
      //   return
      // }
      const params = {
        userId: this.bindDistrictForm.userId,
        districtIdList: this.bindDistrictForm.districtIds
      }
      addOverseasUserDistrict(params).then((res) => {
        console.log('saveBindDistrict', res)
        this.$message.success('绑定成功')
        this.bindDistrictDialogVisible = false
        this.getDataList()
      }).catch((err) => {
        console.log('绑定赛区失败', err)
        this.$message.error('绑定赛区失败')
      })
    },
    // 关闭绑定赛区对话框
    bindDistrictDialogClose () {
      this.$refs.bindDistrictFormRef && this.$refs.bindDistrictFormRef.resetFields()
      this.bindDistrictForm.userId = ''
      this.bindDistrictForm.districtIds = []
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.div_algin_right {
  text-align: right;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.edit-selecttype-backView {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.examinee-button-type {
  width: 200px;
  margin-bottom: 15px;
}
</style>
